import { Mapper } from "../../../../../lib/utils/mapper";
import { getBonusxApiConfigV2 } from "../../../../common/bonusxApiConfig";
import type { IApiClientService } from "../../../ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../AxiosApiClientInstance/AxiosApiClientInstance";
import { ExternalUrlSessionDto } from "../../dtos/external-url-session.dto";
import { SelfPortalPageDto } from "../../dtos/self-portal-page.dto";
import { UserSubscriptionDto } from "../../dtos/user-subscription/user-subscription.dto";
import type { IUserSubscriptionDatasource } from "./user-subscription.datasource.interface";

export class UserSubscriptionDataSource implements IUserSubscriptionDatasource {
  private readonly _OPTIONS = getBonusxApiConfigV2();
  private readonly _BASE_URL = "/subscriptions";

  constructor(private readonly _client: IApiClientService = new AxiosApiClientInstance()) {}

  async getCurrentUserSubscription(): Promise<UserSubscriptionDto> {
    const { data } = await this._client.get(`${this._BASE_URL}/account`, this._OPTIONS);

    if (!data) {
      throw new Error("User subscription not available");
    }

    const mappedDto = Mapper.mapData(UserSubscriptionDto, data);

    return mappedDto;
  }

  async getSelfPortalPage(): Promise<SelfPortalPageDto> {
    const { data } = await this._client.get(`${this._BASE_URL}/self-portal-page`, this._OPTIONS);

    if (!data) {
      throw new Error("Self portal page not available");
    }

    const mappedDto = Mapper.mapData(SelfPortalPageDto, data);

    return mappedDto;
  }

  async generateCheckoutPageForItem(item: string, redirectUrlToBeEncoded: string): Promise<ExternalUrlSessionDto> {
    const { data } = await this._client.post(
      `${this._BASE_URL}/generate-checkout-page-for-item`,
      { item },
      { ...this._OPTIONS, params: { redirectUrl: redirectUrlToBeEncoded } }
    );

    if (!data) {
      throw new Error("Checkout page not available");
    }

    const mappedDto = Mapper.mapData(ExternalUrlSessionDto, data);

    return mappedDto;
  }

  async renewSubscription(): Promise<void> {
    await this._client.post(`${this._BASE_URL}/renewal-subscription`, null, this._OPTIONS);
  }
}
